import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import { tracker as CLICKSTREAM } from '@zg-rentals/clickstream';
import type { CmsInfo, Exposure } from './types';

export const analytics = defineAnalytics({ CLICKSTREAM });

export const trackCmsEvent = analytics.createTrackEvent<'CLICKSTREAM', CmsInfo>('CLICKSTREAM');

export const trackExperimentEvent = analytics.createTrackEvent<'CLICKSTREAM', Exposure>('CLICKSTREAM');
